export default function IconMenuReport () {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14.7208 0.825795L1.36726 3.45991H14.7208V0.825795ZM0.472617 3.75872L0.597634 3.71697V3.50173H0.298817L0.384655 3.75872H0.472617ZM9.53674e-07 4.05754V3.28649L15.3184 -0.00390625V4.05754H9.53674e-07Z"
        fill="black"/>
      <path
        d="M0.597634 4.05466V19.3942H3.8557V4.05466H0.597634ZM4.45333 3.45703V19.9918H9.53674e-07L9.53675e-07 3.45703H4.45333Z"
        fill="black"/>
      <path d="M4.45332 4.05466V19.4013H19.4024V4.05466H4.45332ZM20 3.45703V19.9989H3.85569V3.45703H20Z" fill="black"/>
      <path fillRule="evenodd" clipRule="evenodd"
            d="M16.6441 9.18106L11.0366 14.7886L7.91078 11.6634L8.42773 11.1463L11.0365 13.7546L16.1271 8.66406L16.6441 9.18106Z"
            fill="black"/>
    </svg>
  )
}
